// src/utils/text.js

export function limparTexto(valor) {
  if (!valor) return '';

  return valor
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove acentos
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .toUpperCase(); // remove pontuação
}


// WEBPACK FOOTER //
// ./src/utils/text.js